import Component from '../core/Component'
import { queryAll } from '../utils/dom'
import Scroll from '../services/Scroll'
import enquire from 'enquire.js'
import EventBus from '../core/EventBus'

const STATES = {
    ACTIVE: 'is-active',
    READY: 'is-ready'
}

export default class PageNavigation extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            bar: null,
            content: null
        }

        this.state = {
            from: 0,
            to: 0,
            dir: 1,
            active: false,
            limit: 0,
            current: null,
            sections: {},
            scroll: 0,
            windowHalfHeight: 0,
            attached: false,
            canAttach: false
        }

        this.enquireHandler = {
            match: this.attach,
            unmatch: this.detach
        }

        this.enquireQuery = 'screen and (min-width: 104em)'

    }

    get source() {
        return document.getElementById('page-header-links')
    }

    get footer() {
        return document.getElementById('footer')
    }

    prepare() {
        enquire.register(this.enquireQuery, this.enquireHandler)
        EventBus.on('swup:aftercontentchange', this.handleSwupContentChange)
    }

    destroy() {
        enquire.unregister(this.enquireQuery, this.enquireHandler)
        EventBus.off('swup:aftercontentchange', this.handleSwupContentChange)
    }

    attach = () => {
        this.state.canAttach = true
        const source = this.source

        if (!source) {
            return
        }

        this.state.attached = true

        this.ref.content.innerHTML = queryAll('a', source)
            .map(element => element.outerHTML)
            .join(' ')

        this.ref.links = queryAll('a', this.ref.content)

        this.ref.sections = this.ref.links
            .map(element => element.getAttribute('href').split('#')[1])
            .map(id => document.getElementById(id))
            .filter(element => element)
            .map(element => element.closest('.Section'))
            .filter(element => element)

        this.links = this.ref.links.reduce((acc, element) => {
            const id = element.getAttribute('href').split('#')[1]

            if (id) {
                acc[id] = element
            }
            return acc
        }, {})

        this.element.classList.add(STATES.READY)

        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)
        this.resize()
    }

    detach = () => {
        this.state.canAttach = false
        this.state.attached = false
        this.element.classList.remove(STATES.READY)
        this.element.classList.remove(STATES.ACTIVE)
        this.ref.content.innerHTML = ''
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
    }

    handleScroll = ({ offset }) => {
        this.state.dir = this.state.scroll < offset.y ? 1 : -1
        this.state.scroll = offset.y

        this.render(offset.y)
    }

    handleResize = () => {
        this.resize()
    }

    handleSwupContentChange = () => {
        this.refresh()
    }

    refresh() {
        if (!this.state.canAttach) {
            return
        }
        if (this.state.attached) {
            this.detach()
        }

        this.attach()
    }

    resize() {
        const scrollTop = Scroll.getScroll().y
        const sourceBox = this.source.getBoundingClientRect()
        const footerBox = this.footer.getBoundingClientRect()

        this.sections = this.ref.sections
            .map(element => {
                const box = element.getBoundingClientRect()

                return {
                    element,
                    id: element.id,
                    from: box.top + scrollTop,
                    to: box.top + box.height + scrollTop
                }
            })

        // vyjede 50 px pod navigaci
        this.state.from = sourceBox.top + sourceBox.height + 50 + scrollTop

        // zajede, kdyz je posledni sekce 100 px od stredu viewportu
        this.state.to = Math.max(...this.sections.map(item => item.to)) - window.innerHeight/2 + 100

        this.state.limit = Scroll.getLimit().y
        this.state.windowHalfHeight = window.innerHeight / 2
        this.state.box = this.element.getBoundingClientRect()

        this.render(scrollTop)
    }

    render(y = 0) {
        // active section
        const current = this.sections.find(item => item.from < y + this.state.windowHalfHeight && item.to > y + this.state.windowHalfHeight)?.id

        if (current !== this.state.current) {
            this.state.current = current
            if (current) {
                const box = this.links[current].getBoundingClientRect()
                this.ref.bar.style.top = `${box.top - this.state.box.top - 2}px`
                this.ref.bar.style.height = `${box.height}px`
            } else {
                this.ref.bar.removeAttribute('style')
            }
        }

        if ((y < this.state.from || y > this.state.to) && this.state.active) {
            this.state.active = false
            this.element.classList.remove(STATES.ACTIVE)
        }

        if (y > this.state.from && y < this.state.to && !this.state.active) {
            this.state.active = true
            this.element.classList.add(STATES.ACTIVE)
        }
    }

}
